import React, { useState } from 'react';
import { shape, arrayOf, string } from 'prop-types';
import classNames from 'classnames';
import Modal from 'common/components/modals/Modal';
import Button from 'common/components/Button';
import InlineNotification from 'apps/notification/components/InlineNotification';
import { TranslatedMessage } from 'common/components/Intl';

export default function RemovedFromCartNotificationModal({
  pods,
  bodyClassName,
}) {
  const [modalActive, setModalActive] = useState(true);

  const onRequestClose = () => {
    setModalActive(false);
  };

  return (
    <Modal
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      closable={true}
      isOpen={modalActive}
      onRequestClose={onRequestClose}
      bodyClassName={classNames(
        'build-your-plan__removed-from-cart__modal-body',
        bodyClassName
      )}
    >
      <div className="build-your-plan__removed-from-cart__content">
        <h3 className="natural-heading--small">
          <TranslatedMessage
            id={'plan_builder.removed_from_cart_notification.title'}
          />
        </h3>

        {pods.map(pod => (
          <div
            key={pod.name}
            className="build-your-plan__removed-from-cart__pod"
          >
            <img
              className="build-your-plan__removed-from-cart__pod-image"
              src={pod.image_url}
            />
            <div className="build-your-plan__removed-from-cart__pod-text">
              <div className="build-your-plan__removed-from-cart__pod-name text--body">
                {pod.name}
              </div>
              <TranslatedMessage
                id="cart.nicotine_strength"
                values={{ strength: pod.nicotine_strength_percent }}
                className="text--body--small"
              />
            </div>
          </div>
        ))}

        <InlineNotification
          className="build-your-plan__removed-from-cart__notification"
          text={
            <TranslatedMessage id="plan_builder.removed_from_cart_notification.minimum_items_note" />
          }
        />
      </div>

      <div className="build-your-plan__removed-from-cart__edit-button-container">
        <Button
          className="build-your-plan__removed-from-cart__edit-button"
          onClick={onRequestClose}
        >
          <TranslatedMessage
            id={
              'plan_builder.removed_from_cart_notification.actions.edit_subscription'
            }
          />
        </Button>
      </div>
    </Modal>
  );
}

RemovedFromCartNotificationModal.propTypes = {
  bodyClassName: string,
  pods: arrayOf(
    shape({
      id: string,
      image_url: string,
      name: string,
      nicotine_strength_percent: string,
    })
  ),
};
